import React from "react";
import styles from "./Main.module.css";
import secondContentsImg from "../../Img/Main/secondContents.png";
import Cree from "../../common/Interview/Cree/Cree";
import Bob from "../../common/Interview/Bob/Bob";
import Richard from "../../common/Interview/Richard/Richard";
import Paul from "../../common/Interview/Paul/Paul";
import Dunkun from "../../common/Interview/Dunkun/Dunkun";
const Main = ({ isDarkMode }) => {
  return (
    <div className={!isDarkMode ? styles.container : styles.dark_container}>
      <div className={styles.topContents}>
        <div className={styles.topText}>
          <div>먼데이오프는</div> <div>전 세계 사람들이 공감할 수 있는</div>
          <div> 게임을 만들어요.</div>
        </div>
      </div>

      <div className={styles.secondContents}>
        <img src={secondContentsImg} alt="" />
      </div>

      <div className={styles.thirdContents}>
        <div className={styles.thirdContentsText}>
          <div>상상해 본 적 있나요?</div>
          <div>지구 반대편에서 내가 만든 게임을 플레이하는 모습을요!</div>
          <div>
            하루 평균 70만명 이상의 전 세계 유저가 우리 게임을 즐기고 있어요.
            먼데이오프와 함께 글로벌 게임 차트를 접수할 여러분을 기다립니다.
          </div>
        </div>
      </div>
      <div className={styles.fourthContents}>
        <div className={styles.contentsTitle}>우리가 일하는 방식</div>
        <div className={styles.interviewBox}>
          <Dunkun />
          <Cree />
          <Bob />
          <Richard />
        </div>
      </div>
    </div>
  );
};

export default Main;
